export default function forOwn(obj, callback) {
  // Object(): IE 11's Object.keys throws on a primitive
  var keys = Object.keys(Object(obj));
  var l = keys.length;
  var i = 0;
  var key;
  while (i < l) {
    key = keys[i];
    i += 1;
    callback(obj[key], key);
  }
}